export default {
  'timeSelect.lastDay': '最近1天',
  'timeSelect.last7Day': '最近7天',
  'timeSelect.lastMonth': '上个月',
  'timeSelect.thisMonth': '当月',
  'timeSelect.userDefined': '选择日期范围',
  'timeSelect.SelectAll': 'Select All',
  'timeSelect.DeselectAll': 'Deselect All',
};
